import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation deleteNpoReportAnswerValidation(
    $id: Int!,
  ) {
    deleteNpoReportAnswerValidation(
      id: $id,
    ) {
      success
    }
  }
`;

export function useDeleteNpoReportAnswerValidation() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(query, variables, () => {
      if (typeof onFinish === 'function') {
        onFinish();
      }
    });
  };
  return { data, isLoading, run };
}


